/**
 * ResetPasswordForm.jsx
 * Created by michaelbray on 2/14/18.
 * Updated by Destin Frasier on 1/11/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Button from '../../../sharedComponents/Button';
import Label from '../../../sharedComponents/Label';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    errorText: PropTypes.string,
    signIn: PropTypes.func,
    confirmEmail: PropTypes.func,
    disableResetLinkBtn: PropTypes.bool
};

export default class ResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: ''
        };

        this.emailTextChange = this.emailTextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.email.focus();
    }

    emailTextChange(e) {
        this.setState({
            email: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();
        this.props.confirmEmail({
            email: this.state.email.trim()
        });
    }

    render() {
        let error = null;

        if (this.props.errorText) {
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }

        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={6} md={5} xl={4} className="rec-acct-modal-reset-password-body">
                    <Heading
                        headingLevel={1}
                        appearance="display"
                        className="rec-acct-modal-title"
                        id="resetPasswordModalHeading">
                        Reset Password
                    </Heading>
                    <p>Enter the email address associated with your account. We&#39;ll send a link to reset your password.</p>
                    {error}
                    <form onSubmit={this.submitForm}>
                        <div className="form-item-wrap">
                            <Label
                                htmlFor="rec-acct-email">
                                Email
                            </Label>
                            <input
                                ref={(email) => this.email = email}
                                onChange={(event) => this.emailTextChange(event)}
                                id="rec-acct-email"
                                className="rec-acct-email" />
                        </div>
                        <Button
                            size="lg"
                            shouldFitContainer
                            className="rec-acct-reset-btn"
                            type="submit"
                            title="Send Reset Link"
                            aria-label="Send Reset Link"
                            isDisabled={this.props.disableResetLinkBtn}>
                            Send Reset Link
                        </Button>
                    </form>
                    <div className="rec-acct-modal-footer">
                        <Button
                            appearance="link"
                            iconBeforeElement={<Icons.IconChevronLeft />}
                            onClick={this.props.signIn}
                            title="Back to Log In"
                            aria-label="Back to Log In">
                            Back to Log In
                        </Button>
                    </div>
                </FlexCol>
            </FlexRow>
        );
    }
}

ResetPasswordForm.propTypes = propTypes;
